import { configureStore } from "@reduxjs/toolkit";
import themeSlice from "../helpers/core/slice";

export const store = configureStore({
  reducer: {
    theme: themeSlice,
  },
});
